<template>
    <div>
        <ol class="breadcrumbs">
            <li><a href="/panel-docentes"><i class="fas fa-home mr-1"></i> Inicio</a></li>
            <li class="current">{{ruta}}</li>
        </ol>
    </div>
</template>
<script>
export default {
    props:['ruta']
}
</script>
<style scoped>
a {
  color: #5486e2 !important;
  text-decoration: none;
}
.breadcrumbs{
    padding: 0;
}

.breadcrumbs li{
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  margin: 0.5em 0;
}
.breadcrumbs li::after{
  display: inline-block;
  content: '/';
  margin: 0 .6em;
  color: #959fa5;
}

.breadcrumbs li:last-of-type::after{
  display: none;
}

.breadcrumbs li.current > *{
  color: #444444;
}

</style>